<div class="bg-white rounded-xl h-full overflow-auto">
  <div class="bg-[#F5F5FA] flex flex-col items-center gap-3">
    <div class="text-3xl font-semibold mt-10">
      {{ 'documentation.title' | translate }}
    </div>
    <div class="text-neutral text-sm">
      {{ 'documentation.subTitle' | translate }}
    </div>
    <mat-form-field class="w-3/5 mt-10">
      <input type="email" matInput [placeholder]="'documentation.placeholderSearch' | translate" />
      <mat-icon matSuffix>person</mat-icon>
    </mat-form-field>
    <div class="py-3 px-6">
      <div class="w-1/2 py-3 flex justify-between gap-10">
        @for (tab of TABS_MOCKS; track $index) {
          <div
            class="font-semibold p-2 text-neutral cursor-pointer whitespace-nowrap border-b-2 border-transparent"
            [class.!border-primary]="tab.index === tabSelected"
            (click)="onTabClick(tab.index)"
          >
            {{ tab.title | translate }}
          </div>
        }
      </div>
    </div>
  </div>
  <div class="py-10 flex justify-center">
    <div class="w-4/5 flex gap-10 justify-between">
      <div>
        <div class="bg-[#F5F5FA] h-32 w-32 rounded-xl"></div>
        <div class="text-lg font-semibold my-6">Getting started</div>
        <div class="text-neutral">Content</div>
      </div>
      <div>
        <div class="bg-[#F5F5FA] h-32 w-32 rounded-xl"></div>
        <div class="text-lg font-semibold my-6">Intro #1</div>
        <div class="text-neutral">Content</div>
      </div>
      <div>
        <div class="bg-[#F5F5FA] h-32 w-32 rounded-xl"></div>
        <div class="text-lg font-semibold my-6">Intro #2</div>
        <div class="text-neutral">Content</div>
      </div>
    </div>
  </div>
</div>
